function globals() {
  console.log('ᕕ( ᐛ )ᕗ Globals...');

  function toggleMenu() {
    const toggle = document.querySelector('.js-toggle-menu');
    const menu = document.querySelector('.js-menu');

    if (!toggle || !menu) return;

    const openIcon = toggle.querySelector('.toggle-icon--open');
    const closeIcon = toggle.querySelector('.toggle-icon--close');

    function openMenu() {
      menu.classList.add('is-active');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (openIcon) openIcon.classList.add('hidden');
      if (closeIcon) closeIcon.classList.remove('hidden');
    }

    function closeMenu() {
      menu.classList.remove('is-active');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (openIcon) openIcon.classList.remove('hidden');
      if (closeIcon) closeIcon.classList.add('hidden');
    }

    toggle.addEventListener('click', function () {
      if (menu.classList.contains('is-active')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Backdrop and explicit close buttons
    menu.querySelectorAll('.js-close-menu').forEach(function (btn) {
      btn.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('is-active')) {
        closeMenu();
        toggle.focus();
      }
    });

    // Close on resize to desktop
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024) closeMenu();
    });

    // Mobile accordion (destinations sub-menu)
    menu.querySelectorAll('.js-mobile-accordion').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const body = this.nextElementSibling;
        const isOpen = body.classList.contains('is-open');

        // Close any other open accordion
        menu.querySelectorAll('.mobile-accordion-body.is-open').forEach(function (openBody) {
          openBody.classList.remove('is-open');
          openBody.previousElementSibling.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          body.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function headerScroll() {
    const header = document.getElementById('header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    });
  }

  function setActiveNav() {
    const raw = window.location.pathname;
    const path = raw.replace(/\/$/, '') || '/';

    // Desktop top-level links
    document.querySelectorAll('.header-nav__link:not(.header-nav__link--btn)').forEach(function (link) {
      const href = (link.getAttribute('href') || '').replace(/\/$/, '');
      if (!href) return;
      if (href === '/' ? path === '/' : path.startsWith(href)) {
        link.classList.add('is-active');
      }
    });

    // Desktop dropdown children — also marks the parent button active
    document.querySelectorAll('.header-dropdown__link').forEach(function (link) {
      const href = (link.getAttribute('href') || '').replace(/\/$/, '');
      if (!href || href === '/') return;
      if (path.startsWith(href)) {
        link.classList.add('is-active');
        const parentItem = link.closest('.has-dropdown');
        if (parentItem) {
          const btn = parentItem.querySelector('.header-nav__link--btn');
          if (btn) btn.classList.add('is-active');
        }
      }
    });

    // Mobile links
    document.querySelectorAll('.mobile-drawer__link:not(.mobile-drawer__link--accordion), .mobile-drawer__child-link').forEach(function (link) {
      const href = (link.getAttribute('href') || '').replace(/\/$/, '');
      if (!href) return;
      if (href === '/' ? path === '/' : path.startsWith(href)) {
        link.classList.add('is-active');
      }
    });
  }

  function initDesktopDropdowns() {
    // Allow click/touch to toggle dropdown (for tablet + keyboard use)
    document.querySelectorAll('.js-dropdown-trigger').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        const item = this.closest('.has-dropdown');
        const isOpen = item.classList.contains('is-open');

        // Close all open dropdowns
        document.querySelectorAll('.header-nav__item.has-dropdown.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('.js-dropdown-trigger').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.has-dropdown')) {
        document.querySelectorAll('.header-nav__item.has-dropdown.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('.js-dropdown-trigger').setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.header-nav__item.has-dropdown.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('.js-dropdown-trigger').setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  function smoothScroll() {
    document.querySelectorAll('.js-scroll-link').forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href').substring(1);
        if (!targetId) {
          return;
        }
        e.preventDefault();
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 72, // Adjust for fixed navbar
            behavior: 'smooth',
          });

          // Update the URL without jumping
          history.pushState(null, null, `#${targetId}`);
        }
      });
    });
  }

  function backToTop() {
    const element = document.querySelector('a[href="#top"]');
    if (!element) {
      return;
    }

    element.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function initSlider() {
    if (!window.Splide) {
      console.warn('Splide is not defined.');

      return;
    }

    document.querySelectorAll('.splide').forEach((el) => {
      if (el.classList.contains('splide--gallery')) {
        const splide = new Splide(el, {
          type: 'fade',
          rewind: true,
          perPage: 1,
          perMove: 1,
          pagination: true,
          arrows: true,
          autoplay: false,
        });

        splide.mount();

        return;
      }

      const splide = new Splide(el, {
        type: 'fade',
        rewind: true,
        perPage: 1,
        perMove: 1,
        pagination: false,
        arrows: false,
        autoplay: true,
        speed: 3000,
      });

      splide.mount();
    });
  }

  function initAccordion() {
    // Select all accordion items
    const accordions = document.querySelectorAll('.accordion');

    accordions.forEach((accordion) => {
      // Find all accordion headings within this accordion container
      const headings = accordion.querySelectorAll('[id^="accordion-heading-"]');

      headings.forEach((heading) => {
        // Extract the index from the heading id (e.g., "accordion-heading-1" -> "1")
        const index = heading.id.split('-').pop();

        // Find the corresponding body
        const body = document.getElementById(`accordion-body-${index}`);
        const icon = heading.querySelector('[data-accordion-icon]');

        if (body && icon) {
          // State tracking for this specific accordion item
          let isOpen = heading.classList.contains('is-active');
          // Initialize body style for animation
          if (!isOpen) {
            body.style.maxHeight = '0px';
          }
          body.style.overflow = 'hidden';
          body.style.transition = 'max-height 0.3s ease-out';

          // Add click event listener
          heading.addEventListener('click', function () {
            // Toggle state
            isOpen = !isOpen;

            if (isOpen) {
              // Open the accordion
              body.style.maxHeight = `${body.scrollHeight}px`;
              // Rotate icon (remove rotate-180 class)
              icon.classList.remove('rotate-180');
            } else {
              // Close the accordion
              body.style.maxHeight = '0px';
              // Rotate icon back (add rotate-180 class)
              icon.classList.add('rotate-180');
            }
          });

          // Optional: Handle window resize for open accordions
          window.addEventListener('resize', function () {
            if (isOpen) {
              body.style.maxHeight = `${body.scrollHeight}px`;
            }
          });
        }
      });
    });
  }

  toggleMenu();
  headerScroll();
  setActiveNav();
  initDesktopDropdowns();
  smoothScroll();
  backToTop();
  initSlider();
  initAccordion();
}

(function run() {
  console.log('ᕕ( ᐛ )ᕗ Running...');

  document.addEventListener('DOMContentLoaded', function () {
    globals();
  });
})();
